/**
 * Applies the order of orderedFields to the columns. Columns not in
 * orderedFields, e.g. not rendered by the grid, keep their relative order last.
 */
export const reorderColumns = (
  columns: string[],
  orderedFields: string[],
): string[] => {
  const reordered = [
    ...orderedFields.filter(field => columns.includes(field)),
    ...columns.filter(column => !orderedFields.includes(column)),
  ];

  return reordered.length === columns.length &&
    reordered.every((column, index) => column === columns[index])
    ? columns
    : reordered;
};
